'use client';

import { Alert } from '@/components/ui/alert';
import { useFeatureFlags } from '@/hooks/use-feature-flags';
import clsx from 'clsx';

export function WarningBanner() {
  const { warningBanner } = useFeatureFlags();

  if (!warningBanner?.enabled) {
    return null;
  }

  return (
    <Alert severity={warningBanner.level || 'warning'}>
      <p
        className={clsx(
          'font-semibold text-sm',
          warningBanner.level === 'warning' && 'text-warning-800',
          warningBanner.level === 'error' && 'text-error-800',
          warningBanner.level === 'info' && 'text-info-800'
        )}
      >
        {warningBanner.message ||
          'We are experiencing some issues with our system. We apologize for the inconvenience and are working on it. Contact support for more information.'}
      </p>
    </Alert>
  );
}
